<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <sector-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></sector-add-form>
                <sector-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></sector-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import SectorAddForm from './forms/add/representations/WizardForm'
    import SectorUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../sectorStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            SectorAddForm,
            SectorUpdateForm
        },

    }
</script>
